import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=4451b31c&"
import script from "./InputSearch.vue?vue&type=script&lang=ts&"
export * from "./InputSearch.vue?vue&type=script&lang=ts&"
import style0 from "./InputSearch.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports